export enum CommonRoutePathsEnum {
  NOT_FOUND = '*',
  REDIRECTED_TO_NOT_FOUND = '/404',
}
